import { jsx as _jsx } from "react/jsx-runtime";
import "./typeWriter.style.css";
export const TypeWriter = ({ content, id, className }) => {
    return (_jsx("div", { id: `type-writer-${id}`, className: `typeWriter ${className}`, children: _jsx("div", { className: "content", children: content }) }));
};
